export default __webpack_public_path__ + "static/media/ols_b.6e672c0e.png";